module.exports = __webpack_public_path__ + "static/media/498GriffinStNW_2018-06-05_2.d585472f.jpg";